import { useState } from "react";
import { AmbientGlow, TapeLabel } from "./_shared";

// Ported from Claude Design handoff (sections-rest: FAQ).
// Two-column layout: sticky eyebrow+h2 on left, accordion list on right.

const ITEMS = [
  {
    q: "O que exatamente o Cyphron monitora?",
    a:
      "O Cyphron monitora uptime, certificados SSL, registros DNS, presença em blacklists, vulnerabilidades conhecidas (CVEs), logs de acesso e eventos de segurança do Cloudflare — tudo de forma contínua, 24 horas por dia, com 11+ tipos de monitoramento.",
  },
  {
    q: "Preciso de uma equipe técnica para usar?",
    a:
      "Não. A plataforma foi desenhada para ser usada por qualquer pessoa. Os relatórios são gerados em linguagem simples pela IA, em português. O painel mostra um score visual de 0 a 100 que resume a situação da sua empresa. Nós configuramos tudo para você.",
  },
  {
    q: "Qual é o tempo para começar a ver resultados?",
    a:
      "Em 24 horas o monitoramento já está ativo e os primeiros alertas começam a chegar. Em 48 horas você recebe o primeiro relatório com análise da IA. Em uma semana já tem dados suficientes para uma visão completa da sua postura de segurança.",
  },
  {
    q: "O Cyphron substitui um pentest?",
    a:
      "Não, e não pretende. Pentest é um snapshot — testa o que pode ser explorado em um momento específico. Cyphron é monitoramento contínuo — vigia o que existe 24/7. São complementares. Cyphron te mostra o dia a dia; pentest te mostra as portas abertas.",
  },
  {
    q: "Meus dados ficam seguros na plataforma?",
    a:
      "Sim. Utilizamos isolamento de dados por tenant, criptografia e controle de acesso rigoroso. Operadores da plataforma nunca têm acesso aos dados de segurança dos clientes — isso é uma garantia arquitetural, não só uma política. O Cyphron foi projetado desde o início com conformidade à LGPD.",
  },
  {
    q: "Como funciona a contratação?",
    a:
      "Você entra em contato com nosso consultor, que entende sua necessidade e configura todo o ambiente de monitoramento. Quando estiver pronto, você recebe um convite por e-mail para acessar seu painel personalizado. Sem burocracia, sem instalação.",
  },
  {
    q: "O que acontece se o Cyphron detectar uma ameaça?",
    a:
      "Você recebe alertas automáticos classificados por severidade (crítico, alto, médio, baixo). O relatório da IA explica o que foi encontrado em linguagem simples e recomenda ações. Nós alertamos — você ou um especialista toma a ação de remediação.",
  },
];

export function FAQAccordion() {
  const [open, setOpen] = useState<number>(0);
  return (
    <section
      id="faq"
      className="cy-section"
      style={{
        position: "relative",
        padding: "140px 40px",
        background: "var(--cy-bg)",
        borderTop: "1px solid var(--cy-ink-10)",
        overflow: "hidden",
      }}
    >
      <AmbientGlow variant="bl" />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 1100,
          margin: "0 auto",
        }}
      >
        <div
          className="cy-faq-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "320px 1fr",
            gap: 80,
            alignItems: "start",
          }}
        >
          <div className="cy-faq-sticky" style={{ position: "sticky", top: 100 }}>
            <TapeLabel>FAQ</TapeLabel>
            <h2
              style={{
                fontFamily: "var(--cy-fs-sans)",
                fontSize: "clamp(32px, 4vw, 44px)",
                lineHeight: 1.06,
                letterSpacing: "-0.03em",
                fontWeight: 500,
                margin: "20px 0 0",
                color: "var(--cy-ink-100)",
                textWrap: "balance",
              }}
            >
              Perguntas Frequentes
            </h2>
          </div>
          <div>
            {ITEMS.map((it, i) => {
              const isOpen = open === i;
              const isLast = i === ITEMS.length - 1;
              return (
                <div
                  key={i}
                  style={{
                    borderTop: "1px solid var(--cy-ink-10)",
                    ...(isLast
                      ? { borderBottom: "1px solid var(--cy-ink-10)" }
                      : {}),
                  }}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    style={{
                      width: "100%",
                      padding: "24px 0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      textAlign: "left",
                      fontFamily: "var(--cy-fs-sans)",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 17,
                        fontWeight: 500,
                        color: "var(--cy-ink-100)",
                        letterSpacing: "-0.01em",
                      }}
                    >
                      {it.q}
                    </span>
                    <span
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: "50%",
                        border: `1px solid ${
                          isOpen ? "var(--cy-accent)" : "var(--cy-ink-20)"
                        }`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition:
                          "transform .25s ease, border-color .25s ease, color .25s ease",
                        transform: isOpen ? "rotate(45deg)" : "rotate(0)",
                        color: isOpen ? "var(--cy-accent)" : "var(--cy-ink-60)",
                        fontSize: 16,
                        lineHeight: 1,
                        flexShrink: 0,
                      }}
                    >
                      +
                    </span>
                  </button>
                  <div
                    style={{
                      maxHeight: isOpen ? 600 : 0,
                      overflow: "hidden",
                      transition: "max-height .4s ease",
                    }}
                  >
                    <div
                      style={{
                        padding: "0 0 24px",
                        fontSize: 15,
                        lineHeight: 1.6,
                        color: "var(--cy-ink-60)",
                        maxWidth: 680,
                      }}
                    >
                      {it.a}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
